import type { EnvironmentConfig } from '@core/config-models';
import { EnvConfigBrand, EnvConfigSegment } from '@core/config-models';
import { getBrandName } from '@core/config-angular';

/**
 * Gets the aria-label for the logo-link (to be used in the headers & footer).
 */
export const getLogoHomepageNavigationLabel = (config: EnvironmentConfig) => {
  const isEssent = config.brand === EnvConfigBrand.Essent;
  const isConsument = config.segment === EnvConfigSegment.Consument;
  const brand = getBrandName(config.brand);
  const segment = isConsument ? 'particulier' : 'zakelijk';
  const fullBrandName = isEssent ? `${brand} ${segment}` : brand;

  return `Logo ${fullBrandName} - naar ${fullBrandName} Homepage`;
};
